import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LngDetector from 'i18next-browser-languagedetector';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  "ar": {
      "translation": {
          "Total people enrolled": "إجمالي الأشخاص المسجلين",
          "Total T1Ds patient on treatment": "إجمالي مرضى T1Ds الذين يخضعون للعلاج",
          "Total T1D Inactive patient ": "إجمالي T1D مريض غير نشط",
          "Distribution Of T1D Patients By Gender": "توزيع مرضى T1D حسب الجنس",
          "Distribution Of T1D Patients By Age group": "توزيع مرضى T1D حسب الفئة العمرية",
          "BMI value distribution": "توزيع قيمة مؤشر كتلة الجسم",
          "Diabetes Control Status based on HbA1C\n- Diabetes controlled\n- Diabetes Uncontrolled": "حالة التحكم في مرض السكري على أساس نسبة HbA1C\n- السيطرة على مرض السكري\n- مرض السكري غير المنضبط",
          "Total Patients With Co-Morbidities": "إجمالي المرضى الذين يعانون من أمراض مصاحبة",
          "Complication Reporting Rate": "معدل الإبلاغ عن المضاعفات",
          "Home": "بيت",
          "Pathway": "مسار",
          "Linelist": "القائمة الخطية",
          "Alerts": "التنبيهات",
          "Select filter": "حدد عامل التصفية",
          "Dashboard": "لوحة القيادة",
          "Guinea": "غينيا",
          "Data upload": "تحميل البيانات",
          "Data management": "إدارة البيانات",
          "User management": "إدارةالمستخدم",
          "Facility management": "إدارة المرافق",
          "Activated clients": "العملاء المنشطين",
          "Deactivated clients": "العملاء المعطلين",
          "Search": "يبحث",
          "Go to page": "انتقل إلى صفحة",
          "Page": "صفحة",
          "Of": "ل",
          "Cases": "حالات",
          "Show": "يعرض",
          "UIC": "UIC",
          "Name": "اسم",
          "Age": "عمر",
          "Gender": "جنس",
          "Address": "عنوان",
          "Deactivate": "إلغاء التنشيط",
          "Logout": "تسجيل خروج"
      }
  },
  "en": {
      "translation": {
          "Total people enrolled": "Total people enrolled",
          "Total T1Ds patient on treatment": "Total T1Ds patient on treatment",
          "Total T1D Inactive patient ": "Total T1D Inactive patient ",
          "Distribution Of T1D Patients By Gender": "Distribution Of T1D Patients By Gender",
          "Distribution Of T1D Patients By Age group": "Distribution Of T1D Patients By Age group",
          "BMI value distribution": "BMI value distribution",
          "Diabetes Control Status based on HbA1C\n- Diabetes controlled\n- Diabetes Uncontrolled": "Diabetes Control Status based on HbA1C\n- Diabetes controlled\n- Diabetes Uncontrolled",
          "Total Patients With Co-Morbidities": "Total Patients With Co-Morbidities",
          "Complication Reporting Rate": "Complication Reporting Rate",
          "Home": "Home",
          "Pathway": "Pathway",
          "Linelist": "Line list",
          "Alerts": "Alerts",
          "Select filter": "Select filter",
          "Dashboard": "Dashboard",
          "Guinea": "Guinea",
          "Data upload": "Data upload",
          "Data management": "Data management",
          "User management": "User management",
          "Facility management": "Facility management",
          "Activated clients": "Activated clients",
          "Deactivated clients": "Deactivated clients",
          "Search": "Search",
          "Go to page": "Go to page",
          "Page": "Page",
          "Of": "Of",
          "Cases": "Cases",
          "Show": "Show",
          "UIC": "UIC",
          "Name": "Name",
          "Age": "Age",
          "Gender": "Gender",
          "Address": "Address",
          "Deactivate": "Deactivate",
          "Logout": "Logout"
      }
  },
  "es": {
      "translation": {
          "Total people enrolled": "Total de personas inscritas",
          "Total T1Ds patient on treatment": "Total de pacientes con diabetes tipo 1 en tratamiento",
          "Total T1D Inactive patient ": "Total DT1 Paciente inactivo",
          "Distribution Of T1D Patients By Gender": "Distribución de pacientes con diabetes tipo 1 por género",
          "Distribution Of T1D Patients By Age group": "Distribución de pacientes con diabetes tipo 1 por grupo de edad",
          "BMI value distribution": "Distribución del valor del IMC",
          "Diabetes Control Status based on HbA1C\n- Diabetes controlled\n- Diabetes Uncontrolled": "Estado de control de diabetes basado en HbA1C\n- Diabetes controlada\n- Diabetes no controlada",
          "Total Patients With Co-Morbidities": "Total de pacientes con comorbilidades",
          "Complication Reporting Rate": "Tasa de notificación de complicaciones",
          "Home": "Hogar",
          "Pathway": "Ruta",
          "Linelist": "Lista de líneas",
          "Alerts": "Alertas",
          "Select filter": "Seleccionar filtro",
          "Dashboard": "Panel",
          "Guinea": "Guinea",
          "Data upload": "Carga de datos",
          "Data management": "Gestión de datos",
          "User management": "Gestión de usuarios",
          "Facility management": "Gestión de instalaciones",
          "Activated clients": "Clientes activados",
          "Deactivated clients": "Clientes desactivados",
          "Search": "Buscar",
          "Go to page": "ir a la pagina",
          "Page": "Página",
          "Of": "De",
          "Cases": "Casos",
          "Show": "Espectáculo",
          "UIC": "UIC",
          "Name": "Nombre",
          "Age": "Edad",
          "Gender": "Género",
          "Address": "DIRECCIÓN",
          "Deactivate": "Desactivar",
          "Logout": "Cerrar sesión"
      }
  },
  "fr": {
      "translation": {
          "Total people enrolled": "Nombre total de personnes inscrites",
          "Total T1Ds patient on treatment": "Total des patients atteints de DT1 sous traitement",
          "Total T1D Inactive patient ": "Total DT1 Patient inactif",
          "Distribution Of T1D Patients By Gender": "Répartition des patients DT1 par sexe",
          "Distribution Of T1D Patients By Age group": "Répartition des patients atteints de DT1 par groupe d'âge",
          "BMI value distribution": "Répartition de la valeur de l'IMC",
          "Diabetes Control Status based on HbA1C\n- Diabetes controlled\n- Diabetes Uncontrolled": "Statut de contrôle du diabète basé sur l'HbA1C\n- Diabète contrôlé\n- Diabète incontrôlé",
          "Total Patients With Co-Morbidities": "Nombre total de patients présentant des comorbidités",
          "Complication Reporting Rate": "Taux de rapports de complications",
          "Home": "Maison",
          "Pathway": "Sentier",
          "Linelist": "Liste de lignes",
          "Alerts": "Alertes",
          "Select filter": "Sélectionnez le filtre",
          "Dashboard": "Tableau de bord",
          "Guinea": "Guinée",
          "Data upload": "Téléchargement de données",
          "Data management": "Gestion de données",
          "User management": "Gestion des utilisateurs",
          "Facility management": "Gestion des installations",
          "Activated clients": "Clients activés",
          "Deactivated clients": "Clients désactivés",
          "Search": "Recherche",
          "Go to page": "Aller à la page",
          "Page": "Page",
          "Of": "De",
          "Cases": "Cas",
          "Show": "Montrer",
          "UIC": "CUI",
          "Name": "Nom",
          "Age": "Âge",
          "Gender": "Genre",
          "Address": "Adresse",
          "Deactivate": "Désactiver",
          "Logout": "Se déconnecter"
      }
  },
  "hi": {
      "translation": {
          "Total people enrolled": "कुल नामांकित लोग",
          "Total T1Ds patient on treatment": "उपचाराधीन कुल टी1डी रोगी",
          "Total T1D Inactive patient ": "कुल T1D निष्क्रिय रोगी",
          "Distribution Of T1D Patients By Gender": "लिंग के आधार पर टी1डी रोगियों का वितरण",
          "Distribution Of T1D Patients By Age group": "आयु समूह के अनुसार टी1डी रोगियों का वितरण",
          "BMI value distribution": "बीएमआई मूल्य वितरण",
          "Diabetes Control Status based on HbA1C\n- Diabetes controlled\n- Diabetes Uncontrolled": "HbA1C पर आधारित मधुमेह नियंत्रण स्थिति\n-मधुमेह नियंत्रित\n- मधुमेह अनियंत्रित",
          "Total Patients With Co-Morbidities": "सह-रुग्णता वाले कुल मरीज़",
          "Complication Reporting Rate": "जटिलता रिपोर्टिंग दर",
          "Home": "घर",
          "Pathway": "मार्ग",
          "Linelist": "लाइनलिस्ट",
          "Alerts": "अलर्ट",
          "Select filter": "फ़िल्टर चुनें",
          "Dashboard": "डैशबोर्ड",
          "Guinea": "गिनी",
          "Data upload": "डेटा अपलोड",
          "Data management": "डेटा प्रबंधन",
          "User management": "प्रयोक्ता प्रबंधन",
          "Facility management": "सुविधा प्रबंधन",
          "Activated clients": "सक्रिय ग्राहक",
          "Deactivated clients": "निष्क्रिय ग्राहक",
          "Search": "खोज",
          "Go to page": "पृष्ठ पर जाओ",
          "Page": "पृष्ठ",
          "Of": "का",
          "Cases": "मामलों",
          "Show": "दिखाओ",
          "UIC": "यूआईसी",
          "Name": "नाम",
          "Age": "आयु",
          "Gender": "लिंग",
          "Address": "पता",
          "Deactivate": "निष्क्रिय करें",
          "Logout": "लॉग आउट"
      }
  },
  "ru": {
      "translation": {
          "Total people enrolled": "Всего зачислено людей",
          "Total T1Ds patient on treatment": "Всего пациентов с СД1, находящихся на лечении",
          "Total T1D Inactive patient ": "Всего неактивных пациентов с СД1",
          "Distribution Of T1D Patients By Gender": "Распределение пациентов с СД1 по полу",
          "Distribution Of T1D Patients By Age group": "Распределение пациентов с СД1 по возрастным группам",
          "BMI value distribution": "Распределение значений ИМТ",
          "Diabetes Control Status based on HbA1C\n- Diabetes controlled\n- Diabetes Uncontrolled": "«Статус контроля диабета на основе HbA1C\n- Диабет под контролем\n- Неконтролируемый диабет»",
          "Total Patients With Co-Morbidities": "Всего пациентов с сопутствующими заболеваниями",
          "Complication Reporting Rate": "Частота сообщений об осложнениях",
          "Home": "Дом",
          "Pathway": "Путь",
          "Linelist": "Список строк",
          "Alerts": "Оповещения",
          "Select filter": "Выбрать фильтр",
          "Dashboard": "Панель приборов",
          "Guinea": "Гвинея",
          "Data upload": "Загрузка данных",
          "Data management": "Управление данными",
          "User management": "Управление пользователями",
          "Facility management": "Управление объектом",
          "Activated clients": "Активированные клиенты",
          "Deactivated clients": "Деактивированные клиенты",
          "Search": "Поиск",
          "Go to page": "Перейти на страницу",
          "Page": "Страница",
          "Of": "Из",
          "Cases": "Случаи",
          "Show": "Показывать",
          "UIC": "МСЖД",
          "Name": "Имя",
          "Age": "Возраст",
          "Gender": "Пол",
          "Address": "Адрес",
          "Deactivate": "Деактивировать",
          "Logout": "Выйти"
      }
  },
  "zh": {
      "translation": {
          "Total people enrolled": "报名总人数",
          "Total T1Ds patient on treatment": "接受治疗的 T1D 患者总数",
          "Total T1D Inactive patient ": "T1D 不活动患者总数",
          "Distribution Of T1D Patients By Gender": "T1D 患者的性别分布",
          "Distribution Of T1D Patients By Age group": "T1D 患者年龄分布",
          "BMI value distribution": "BMI值分布",
          "Diabetes Control Status based on HbA1C\n- Diabetes controlled\n- Diabetes Uncontrolled": "“基于 HbA1C 的糖尿病控制状况\n- 糖尿病得到控制\n- 糖尿病不受控制”",
          "Total Patients With Co-Morbidities": "患有合并症的患者总数",
          "Complication Reporting Rate": "并发症报告率",
          "Home": "家",
          "Pathway": "途径",
          "Linelist": "线路表",
          "Alerts": "警报",
          "Select filter": "选择过滤器",
          "Dashboard": "仪表板",
          "Guinea": "几内亚",
          "Data upload": "数据上传",
          "Data management": "数据管理",
          "User management": "用户管理",
          "Facility management": "设施管理",
          "Activated clients": "已激活客户",
          "Deactivated clients": "已停用的客户端",
          "Search": "搜索",
          "Go to page": "转到页面",
          "Page": "页",
          "Of": "的",
          "Cases": "案例",
          "Show": "展示",
          "UIC": "伊利诺伊大学芝加哥分校",
          "Name": "姓名",
          "Age": "年龄",
          "Gender": "性别",
          "Address": "地址",
          "Deactivate": "停用",
          "Logout": "登出"
      }
  }
};

i18n
  .use(LngDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;